var exports = {
  "x": "x805b157e--dff645--button",
};

module.exports = exports;
